module.exports = __webpack_public_path__ + "static/media/AM-Best-best-ratings.8eb8e0a5.jpg";